import { Box, Image, Button } from '@chakra-ui/react';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const navigate = useNavigate();

  return (
    <Box 
      as="header" 
      position="relative"
      width="100%"
      bg="gray.900"
    >
      <Box position="absolute" top={4} right={4}>
        <Button
          leftIcon={<FaHome />}
          colorScheme="blue"
          onClick={() => navigate('/')}
        >
          Home
        </Button>
      </Box>
      <Image
        src="/images/rtc_header1.png"
        alt="RTC Header"
        width="100%"
        height="300px"
        objectFit="contain"
      />
    </Box>
  );
};

// Simplified placeholder with RTC logo
export const InsightLogoPlaceholder = ({ isDragging }: { isDragging: boolean }) => {
  return (
    <Box
      position="relative"
      width="240px"
      height="240px"
      mb="60px"
    >
      <Image
        src="/images/RTC-blue_logo.png"
        alt="Drop Zone"
        boxSize="240px"
        position="relative"
        opacity={isDragging ? 1 : 0.7}
        transition="all 0.3s"
        _hover={{
          opacity: 1
        }}
      />
    </Box>
  );
}; 